import { Navigate, useNavigate } from "react-router-dom";
import { all_routes } from "./all_routes";
import React from "react";
import { getStorageItem } from "../../services/storage.service";

const RootRedirect = () => {
    const routes = all_routes;
    const navigate = useNavigate();
    const token = localStorage.getItem("token");
    const userDetail: any = getStorageItem("userData") || null;
    const userData = userDetail !== null ? JSON.parse(userDetail) : null;
    const ownerType: any = getStorageItem("isRealEstate") || null;
    const isRealEstate = ownerType !== null ? JSON.parse(ownerType) : null;

    // If logged in → go to dashboard
    if (token) {
        if (userData?.role == "owner") {
            if (userData?.has_subscription) {
                if (isRealEstate) {
                    return <Navigate to={routes.dashboard} replace />;
                }
                if (!isRealEstate) {
                    return <Navigate to={routes.nonRealDashboard} replace />;
                }
            }
            else {
                return <Navigate to={routes.pricing} replace />;
            }
        }

        if (userData?.role?.toLowerCase() == 'spouse') {
            return <Navigate to={routes.spouseDashboard} replace />;
        }

        if (userData?.role?.toLowerCase() == 'tax_professional') {
            return <Navigate to={routes.cpaDashboard} replace />;
        }
    }

    // If not logged in → go to login
    return <Navigate to={routes.login} replace />;
};


export default RootRedirect;